<script lang="ts">
	import { TopBottom } from "../SVG/index";

	export let fold = false;
	export let bordercolor = "#707070";

	let mouseenter = false;

</script>

<button
	on:click={() => (fold = !fold)}
	style={`border-color : ${bordercolor}`}
	on:mouseleave={() => (mouseenter = false)}
	on:mouseenter={() => (mouseenter = true)}>
	<div class="container">
		<slot hovering={mouseenter} />
		<span class="direction-box" class:fold>
			{#if $$slots.direction}
				<slot name="direction" hovering={mouseenter} />
			{:else}
				<span class="direction">
					<TopBottom top={false} />
				</span>
			{/if}
		</span>
	</div>
</button>

<style lang="scss">
	@import "../variables.scss";

	button {
		outline: none;
		background: none;
		box-shadow: none;
		border: 1px solid;
		border-radius: 13.5px;
		padding: 6px 10px;
		transition: 0.3s box-shadow;
		&:hover {
			cursor: pointer;
			box-shadow: 1px 1px 3px #70707052;
		}

		.container {
			display: flex;
			align-items: center;
			gap: 6px;

			.direction-box {
				display: flex;
				transition: 0.3s transform;

				&.fold {
					transform: rotate(180deg);
				}
				/* transform: skew(90deg); */
				.direction {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 10px;
					height: 5px;
				}
			}
		}
	}

	@include DesktopSize {
		button {
			padding: 8px 13px;
			border-radius: 19.5px;
			.container {
				gap: 8px;

				.direction-box {
					.direction {
						width: 20px;
						height: 10px;
					}
				}
			}
		}
	}

</style>
